import SurveyBackgroundLayout from '@/components/layout/SurveyBackgroundLayout';
import { SurveyContentPanel, SurveyContentPanelInset } from '@/components/layout/SurveyContentPanel';
import { useSurveyLanguage } from '@/hooks/useSurveyLanguage';
import { useTranslation } from '@/hooks/useTranslation';
import { surveyProfileRedirect, surveyQuestionnaireRedirect, surveyStepRedirect } from '@/lib/surveyFlow';
import { useAppSelector } from '@/stores/hooks';
import { selectOtpDraft, selectPdpaConsent, selectSurveyScreening } from '@/stores/selectors';
import { Navigate } from 'react-router-dom';

/** Placeholder after OTP — incomplete Set A / Set B flows resume at the right step. */
export default function SurveyContinue() {
  const { surveyLanguage } = useSurveyLanguage();
  const { t } = useTranslation();
  const surveyScreening = useAppSelector(selectSurveyScreening);
  const pdpaConsent = useAppSelector(selectPdpaConsent);
  const { customerUuid, otpVerified, questionnaireSet } = useAppSelector(selectOtpDraft);

  if (surveyLanguage == null) {
    return <Navigate to="/" replace />;
  }
  if (surveyScreening == null) {
    return <Navigate to="/age_smoker" replace />;
  }
  if (!pdpaConsent) {
    return <Navigate to="/pdpa" replace />;
  }
  if (!customerUuid || !otpVerified) {
    return <Navigate to="/phone" replace />;
  }
  const questionnaireRedirect = surveyQuestionnaireRedirect(questionnaireSet);
  if (questionnaireRedirect) {
    return <Navigate to={questionnaireRedirect} replace />;
  }
  const stepRedirect =
    questionnaireSet === 'A' || questionnaireSet === 'B'
      ? surveyStepRedirect(questionnaireSet)
      : null;
  if (stepRedirect) {
    return <Navigate to={stepRedirect} replace />;
  }

  const message =
    questionnaireSet === 'B' ? t.surveyContinue.setBMessage : t.surveyContinue.message;

  return (
    <SurveyBackgroundLayout>
      <div className="relative z-10 flex min-h-0 flex-1 flex-col items-center justify-center px-6 py-8">
        <SurveyContentPanelInset>
          <SurveyContentPanel className="text-center">
            <p className="m-0 font-bold">{message}</p>
          </SurveyContentPanel>
        </SurveyContentPanelInset>
      </div>
    </SurveyBackgroundLayout>
  );
}
